/* eslint no-console: 0 */
/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState } from 'react'
import { useLoading } from '../../../../../presentation/contexts/loading'

import { useMe } from '../../../../../presentation/contexts/me'
import { usePage } from '../../../../../presentation/contexts/page'
import { useSnackbar } from '../../../../../presentation/contexts/snackbar'
import CallWaiterEditor from '../../../../../presentation/pages/dashboard/configurations/call-waiter/editor'
import { makeCallWaiter } from '../../../../usecases/call-waiters'

const MakeCallWaiterEditor = () => {
  const { setHeader } = usePage()
  const { me } = useMe()
  const { onSetLoading } = useLoading()
  const { setIsShowing, setText, setType } = useSnackbar()
  const [initialFormData, setInitialFormData] = useState<any>(null)

  const loadCallWaiter = async () => {
    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      const response = await makeCallWaiter(stablishmentId).load()
      const formattedCallWaiters = response.callWaiters.map((callWaiter: any) => ({
        id: callWaiter.id,
        isActive: callWaiter.isActive,
        option: callWaiter.option,
        kind: JSON.parse(callWaiter.kind),
      }))
      setInitialFormData({ callWaiters: formattedCallWaiters })
    } catch (error) {
      console.log(error)
    }
  }

  const dataForm = [
    {
      items: [
        {
          name: 'option',
          component: 'Input',
          value: '',
          placeholder: 'Ex: Trazer um copo',
          title: 'Opção',
          label: 'Opção',
          required: true,
          validations: 'inputRequired',
        },
        {
          name: 'kind',
          component: 'InputCheck',
          required: true,
          value: [],
          title: 'Tipo de resposta',
          label: 'Tipo de resposta',
          options: [
            { label: 'Quantidade', value: '0' },
            { label: 'Campo de texto', value: '1' },
          ],
          validations: 'arrayRequired',
        },
      ],
    },
  ]

  const formatCallWaiterToSubmit = (callWaiters: any) => (
    callWaiters.map((callWaiter: any) => ({
      ...callWaiter,
      option: callWaiter.option.trim(),
      kind: JSON.stringify(callWaiter.kind.reduce((acc: any, current: any) => {
        if (current) {
          acc.push(String(current))
        }
        return acc
      }, [])),
    }))
  )

  const onSubmit = async (values:any): Promise<void> => {
    const itemToSubmit = formatCallWaiterToSubmit(values.callWaiters)
    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id

      await makeCallWaiter(stablishmentId).patch(itemToSubmit)
      await loadCallWaiter()
      setType('success')
      setText('Salvo com sucesso!')
      setIsShowing(true)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    (async () => {
      setHeader({
        title: 'Opções chamar garçom',
        goTo: null,
      })
      onSetLoading(true)
      try {
        await loadCallWaiter()
      } catch (error) {
        console.log(error)
      } finally {
        onSetLoading(false)
      }
    })()
  }, [me, setHeader])

  return (
    <CallWaiterEditor
      initialData={initialFormData}
      dataForm={dataForm}
      onSubmit={onSubmit}
    />
  )
}

export default MakeCallWaiterEditor
